import React from 'react';
import { IconButton } from './ui/Button';
import Tooltip from './ui/Tooltip';
import { useThemeStore } from '../stores/useThemeStore';

interface Props {
  className?: string;
}

const DayModeToggle: React.FC<Props> = ({ className = '' }) => {
  const dayMode = useThemeStore((s) => s.dayMode);
  const toggleDayMode = useThemeStore((s) => s.toggleDayMode);

  const label = dayMode ? 'Switch to dark mode' : 'Switch to day mode';

  return (
    <Tooltip label={label}>
    <IconButton
      label={label}
      onClick={toggleDayMode}
      aria-pressed={dayMode}
      className={className}
    >
      {dayMode ? (
        // Moon — currently in day mode, click to go dark
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
        </svg>
      ) : (
        // Sun — currently in dark mode, click to go day
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <circle cx="12" cy="12" r="4" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1.5M12 19.5V21M3 12h1.5M19.5 12H21M5.64 5.64l1.06 1.06M17.3 17.3l1.06 1.06M5.64 18.36l1.06-1.06M17.3 6.7l1.06-1.06" />
        </svg>
      )}
    </IconButton>
    </Tooltip>
  );
};

export default DayModeToggle;
